import styled from 'styled-components';
import { Col } from '../../../components/Basic/Col/col';

export const Partial = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(0 100 255 / 50%);
  z-index: 10;
`;

export const PartialText = styled(Col)`
  color:white
`;
